import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { FiTrash2, FiSearch } from 'react-icons/fi';

const Container = styled.div`
  padding: 4rem 2rem;
  margin-bottom: 100px;
  h2{
    margin-bottom: 2rem;
    color: #385963;
    text-align:center;
  }
    
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    color:#385963;
  }

  svg {
    margin-right: 0.5rem;
    color: #555;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  th {
    background-color: #f9f9f9;
    color: #385963;
  }

  td:last-child {
    text-align: right;
  }

  td{
  color:#385963;
  }

  button {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    font-size: 1.2rem;
  }

  button:hover {
    color: #c0392b;
  }
`;

// FilePlaceTypeEnum
const RoleEnums = {
  RegisteredUser : 0 ,
  Provider : 1,
  Admin : 2,
  PreApprovedProvider : 3,
};


const ManageUsers = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  const { i18n, t } = useTranslation();
 const tokenString = sessionStorage.getItem("token") ;
 const [registeredUsers, setRegisteredUsers] = useState([]);

useEffect(() => {
  const fetchRegisteredUsers = async () => {

    const active = true;
    const role = RoleEnums.RegisteredUser;
    const requestBody = { role , active };

    try {
      const response = await fetch(
              `${BASE_URL}User/search`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${tokenString}` 
                },
                 body: JSON.stringify(requestBody),
              }
             
            );
          
            const data = await response.json();  
            setRegisteredUsers(data);
            setUsers(data);

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

    } catch (error) {
      console.error('Error fetching registered users:', error);     
    }
  };

  fetchRegisteredUsers();
}, []);


const [users, setUsers] = useState([]);
const [searchTerm, setSearchTerm] = useState('');

const handleDelete = (id) => {
  if (window.confirm(t('confirmDeactivateUser'))) {
    setUsers((prev) => prev.filter((user) => user.id !== id));

    setRegisteredUsers((prev) => prev.filter((user) => user.id !== id));
    
     const deleteUser = async () => {
    try {
      const response = await fetch(`${BASE_URL}User/${id}/deactivate`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${tokenString}` 
          }
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

    } catch (error) {
      console.error('Error DEACTIVATING user:', error);     
    }
  };

   deleteUser();
  }
};

const filteredUsers = users.filter((user) =>
  user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  user.email.toLowerCase().includes(searchTerm.toLowerCase())
);

return (
  <Container>
    <h2>{i18n.t('manageRegisteredUsers')}</h2>
    <SearchBar>
      <FiSearch />
      <input
        type="text"
        placeholder={i18n.t('searchUserText')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </SearchBar>

    <Table>
      <thead>
        <tr>
          <th>{i18n.t('fullname')}</th>
          <th>{i18n.t('email')}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {filteredUsers.length > 0 ? (
          filteredUsers.map((user) => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>
                <button onClick={() => handleDelete(user.id)}>
                  <FiTrash2 />
                </button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3">No users found.</td>
          </tr>
        )}
      </tbody>
    </Table>
  </Container>
);
};


export default ManageUsers
